module.exports = "<app-manual-action\n   *ngFor=\"let action of actions; trackBy: byIndex\"\n   [action]=\"action\">\n</app-manual-action>\n<app-skill-actions-improvement\n   [actions]=\"actions\">\n</app-skill-actions-improvement>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/hr/hr-actions/hr-actions.component.html
// module id = ./src/app/web/game/management/business-units/hr/hr-actions/hr-actions.component.html
// module chunks = main